import { z } from 'zod'

export const platformSchema = z.object({
  facebook: z.boolean(),
  instagram: z.boolean(),
  youtube: z.boolean(),
  tiktok: z.boolean(),
  twitter: z.boolean(),
})

export const periodSchema = z.object({
  three_months: z.boolean(),
  six_months: z.boolean(),
})

export const basicInfoSchema = z.object({
  platform_name_list: z.boolean(),
  gender: z.boolean(),
  country_code: z.boolean(),
  property: z.boolean(),
  description: z.boolean(),
  radar_url: z.boolean(),
  platform_url: z.boolean(),
})

export const socialBasicStatisticsSchema = z.object({
  follower_level: z.boolean(),
  total_follower_count: z.boolean(),
  follower_count: z.boolean(),
  follow_count_growth_count: z.boolean(),
  follow_count_growth_rate: z.boolean(),
  engagement_rate: z.boolean(),
  like_comment_ratio: z.boolean(),
  avg_engagement_count: z.boolean(),
  avg_like_count: z.boolean(),
  avg_comment_count: z.boolean(),
  avg_share_count: z.boolean(),
  reels_engagement_rate: z.boolean(),
  reels_avg_engagement_count: z.boolean(),
  reels_avg_like_count: z.boolean(),
  reels_avg_comment_count: z.boolean(),
  video_view_rate: z.boolean(),
  avg_video_view_count: z.boolean(),
  live_view_rate: z.boolean(),
  avg_live_view_count: z.boolean(),
  short_play_rate: z.boolean(),
  avg_short_play_count: z.boolean(),
  customized_property_statistic: z.boolean(),
  post_count: z.boolean(),
  post_frequency: z.boolean(),
})

export const socialAdvanceStatisticsSchema = z.object({
  score: z.boolean(),
  language: z.boolean(),
  potential: z.boolean(),
  image_estimated_reach: z.boolean(),
  video_estimated_reach: z.boolean(),
  short_estimated_reach: z.boolean(),
  audience_main_age: z.boolean(),
  audience_main_gender: z.boolean(),
  audience_main_country: z.boolean(),
  follower_quality: z.boolean(),
  post_word_of_mouth_volume: z.boolean(),
  video_word_of_mouth_volume: z.boolean(),
  sponsor_post_ratio: z.boolean(),
})

export const collaborationInfoSchema = z.object({
  birthday: z.boolean(),
  profession: z.boolean(),
  contact_info_email: z.boolean(),
  contact_info_other: z.boolean(),
})

const customizedFieldSchema = z.object({
  id: z.number(),
  name: z.string(),
  disable: z.boolean(),
})
export const customizedFieldsSchema = z.array(customizedFieldSchema)
export type CustomizedFields = z.infer<typeof customizedFieldsSchema>
export type CustomizedField = z.infer<typeof customizedFieldSchema>
